require([
    "cart/cartItem",
    "cart/quickEditModal"
],
function (cartItem, quickEditModal) {

    cartItem.initEventHandlers();
    quickEditModal.init();
});

define("Cart/main", function(){});

